import script from "./DetailsTabTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailsTabTitle.vue?vue&type=script&setup=true&lang=ts"

import "./DetailsTabTitle.vue?vue&type=style&index=0&id=4efdb830&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4efdb830"]])

export default __exports__